const footerDataDE = {
  homepage: "/de/",
  categories: [
    {
      title: "Unternehmen",
      links: [
        {
          text: "Trust center",
          href: "/trust-center/"
        },
        {
          //text: "Veranstaltungen",
          text: "Events",
          href: "/events/",
        },
        {
          //text: "Über uns",
          text: "About us",
          href: "/about-us/",
        },
        {
          text: "Jobs",
          href: "/jobs/",
        },
        {
          //text: "Nachhaltigkeit",
          text: "Sustainability",
          href: "/greener-hosting/",
        },
        {
          text: "FAQ",
          href: "/faq/",
        },
        {
          text: "Open source",
          href: "/community/open-source/",
        }
      ],
    },
    {
      title: "Produkt",
      links: [
        {
          text: "Überblick",
          href: "/de/produkt/",
        },
        {
          //text: "Funktionen",
          text: "Features",
          href: "/features/",
        },
        {
          //text: "Preise",
          text: "Pricing",
          href: "/pricing/",
        },
        {
          // TODO: translate
          text: "Pricing calculator",
          href: "/pricing/calculator/"
        }
      ],
    },
    {
      title: "Industrie",
      links: [
        {
          text: "Einzelhandel",
          href: "/de/industrie/einzelhandel/"
        },
        {
          text: "Hochschulbildung",
          href: "/de/industrie/hochschulbildung/"
        },
        {
          text: "SaaS",
          href: "/de/industrie/saas/"
        },
        {
          text: "Reisen und Gastgewerbe",
          href: "/de/industrie/reisen-und-gastgewerbe/"
        },
        {
          text: "Finanzdienstleistungen",
          href: "/de/industrie/finanzdienstleistungen/"
        },
        {
          text: "Regierung",
          href: "/de/industrie/regierung/"
        },
      ]
    },
    {
      title: "Ressourcen",
      links: [
        {
          text: "Fallstudien",
          href: "/de/blog/fallstudien/"
        },
        {
          text: "Blog",
          href: "/de/blog/",
        },
        {
          text: "Developer center",
          href: "https://devcenter.upsun.com/",
        },
        {
          //text: "Dokumentation",
          text: "Documentation",
          href: "https://docs.upsun.com/",
        },
        {
          // TODO: translate
          text: "Cloud regions",
          href: "/regions/",
        },
        {
          text: "Support",
          href: "https://console.upsun.com/-/users/:user/tickets/open",
        },
        {
          //text: "Kontaktieren Sie uns",
          text: "Contact us",
          href: "/contact-us/",
        }
      ],
    },
    {
      // TODO: translate
      title: "Use cases",
      links: [
        {
          text: "SaaS-Hosting",
          href: "/de/loesungen/saas/"
        },
        {
          text: "Anwendungsmodernisierung",
          href: "/de/loesungen/anwendungsmodernisierung/"
        },
        {
          text: "E-Commerce-Hosting",
          href: "/de/loesungen/ecommerce/"
        },
        {
          text: "CMS-Hosting",
          href: "/de/loesungen/cms/"
        },
        {
          text: "Verwaltung mehrerer Standorte",
          href: "/de/loesungen/verwaltung-mehrerer-standorte/"
        },
        {
          text: "SaaS-Erweiterungen",
          href: "/de/loesungen/saas-erweiterungen/"
        },
        {
          text: "Backend-Lösungen",
          href: "/de/loesungen/backend/"
        },
      ]
    },
    {
      // TODO: translate
      title: "Compare",
      links: [
        {
          text: "Heroku-Alternative",
          href: "/de/heroku-alternative/"
        },
        {
          text: "Pantheon-Alternative",
          href: "/de/pantheon-alternative/"
        },
        {
          text: "Managed-Hosting-Alternative",
          href: "/de/managed-hosting-alternative/"
        },
        {
          text: "Fly.io-Alternative",
          href: "/de/fly-io-alternative/"
        },
        {
          text: "Render-Alternative",
          href: "/de/render-alternative/"
        },
        {
          text: "AWS-Alternative",
          href: "/de/aws-alternative/"
        },
        {
          text: "Acquia-Alternative",
          href: "/de/acquia-alternative/"
        },
      ]
    }
  ],
  bottomLinks: [
    {
      href: "/trust-center/legal/tos/",
      //text: "Nutzungsbedingungen",
      text: "Terms of Service",
    },
    {
      href: "/trust-center/privacy/privacy-notice/",
      //text: "Datenschutz",
      text: "Privacy",
    },
    {
      href: "/trust-center/legal/impressum/",
      text: "Impressum",
    },
    {
      href: "/trust-center/security/responsible-disclosure/",
      //text: "Sicherheitsproblem melden",
      text: "Report a security issue",
    },
  ],
};

export default footerDataDE;
